import {NavLink} from 'react-router-dom';
import {Button, Typography} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {AppRoutePaths} from '../../../routing/Routes';
import {EmployeeDto} from '../../../../../../PRMGApiClient';

export const employeeListColumn: ColumnsType<EmployeeDto> = [
  {
    title: t('Last Name'),
    dataIndex: 'lastName',
    key: 'lastName',
    filters: [{text: 'Status', value: true}],
    sorter: true,
    render: (text, record) => (
      <Button type="link" className="p-0">
        <NavLink to={`${AppRoutePaths.employees.url}/${record.id}`}>
          {text}, {record.firstName}
        </NavLink>
      </Button>
    ),
  },
  {
    title: t('Username'),
    dataIndex: 'userName',
    key: 'userName',
    sorter: true,
  },
  {
    title: t('ID'),
    dataIndex: 'id',
    key: 'id',
    sorter: true,
    render: (text) => <Typography.Text strong>{text}</Typography.Text>,
  },
];
